<template>
  <div class="more">
    <div class="bus">
      <h2>Autobus</h2>
      <div
        v-for="(group, direction) in sortedBuses"
        :key="direction"
        class="direction"
        :class="direction"
      >
        <h3>{{ direction | cz }}</h3>
        <h4>Zbývá: {{ not_fulfilled[direction] }} lidí</h4>
        <bus
          v-for="(bus, index) in group"
          :key="bus.id"
          :bus="bus"
          :total_used="usedByMe[direction]"
          :not_fulfilled="not_fulfilled[direction]"
          :class="{ striped: index % 2 == 1 }"
        />
      </div>
    </div>
    <div class="food">
      <h2>Vlny na jídlo</h2>
      <h3>Kliknutím na příslušnou vlnu vyberete svoji preferenci</h3>
      <h4>Máte: {{ totalMyParticipants }} účastníků</h4>
      <div
        v-for="wave in waves"
        :key="wave.id"
        class="item"
        :class="{ disabled: wave.capacity - wave.usedByOther < totalMyParticipants, selected: wave.id == outpost.selectedWave }"
        @click="setWave(wave)"
      >
        <h3>{{ wave.id }}. vlna</h3>
        <span
          class="capacity"
        >{{ ( outpost.selectedWave == wave.id ? totalMyParticipants : 0) + wave.usedByOther }}/{{ wave.capacity }}</span>
      </div>
    </div>
    <div class="shirts">
      <h2>Trička</h2>
      <div class="registration-end">
        Objednávky končí:
        <strong>{{ config.shirtsRegistrationEndAt | cz }}</strong>
      </div>
      <div class="registration-end">
        Cena trička:
        <strong>{{ config.shirtPrice | currency }}</strong>
      </div>
      <div class="registration-end">
        <a :href="config.shirtsGraphicUrl" target="_blank" rel="noopener noreferrer">Náhled grafiky</a>
      </div>
      <div v-for="(count, size) in shirts" :key="size" class="shirt">
        <label>{{ size | cz_size }}:</label>
        <inputerNumber
          :paths="['shirts', size]"
          :name="`Trička ${size}`"
          :disabled="isShirtChangeNotAllowed"
          min="0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { _ } from "../extend";
import inputerNumber from "../components/inputer-number";
import bus from "./parts/bus_item";

export default {
  name: "more",
  components: {
    inputerNumber,
    bus
  },
  computed: {
    ...mapState(["outpost", "buses", "waves", "shirts", "config"]),
    sortedBuses() {
      return _.select(this.buses, (buses) => _.order(buses, b => b.time));
    },
    totalMyParticipants() {
      return _.count(
        this.$store.state.participants,
        participant => participant.playingOutpostId == this.outpost.id
      );
    },
    usedByMe() {
      return _.select(this.buses, buses => _.sum(buses, b => b.usedByMe));
    },
    not_fulfilled() {
      return _.select(this.buses, (buses, direction) => this.totalMyParticipants - this.usedByMe[direction]);
    },
    isShirtChangeNotAllowed() {
      return this.config.shirtsRegistrationEndAt < new Date();
    }
  },
  methods: {
    setWave(wave) {
      if (wave.capacity - wave.usedByOther < this.totalMyParticipants) return;
      this.$store.commit("update", {
        paths: ["outpost", "selectedWave"],
        value: wave.id
      });
    }
  }
};
</script>

<style lang="sass">
@import ../sass/_constants
@import ../sass/_components

.more
  display: grid
  grid-auto-flow: column
  grid-template-columns: 4fr 3fr 3fr
  grid-gap: 2rem
  h2
    font-size: 2rem
  .bus
    display: grid
    h2
      grid-column: 1 / 3
    .direction
      h3
        margin-top: 2rem
      .item
        margin: 1rem 0
        [data-holder=time]
          font-size: 1.5rem
          font-weight: bold
        [data-holder=using]
          display: flex
          input
            @include input-base()
            @include first-input()
          .increase, .decrease
            @include button-secondary()
            @include middle-input()
          .fill
            @include button-primary()
            @include middle-input()
          .empty
            @include button-warning()
            @include last-input()
  .food
    h3
      margin-top: 1rem
    h4
      margin:
        top: 1rem
        bottom: 2rem
    .sideActivity
      margin:
        top: 1rem
        bottom: 4rem
      a
        @include button-secondary()
        font-size: 1.2rem
        font-weight: bold
    .item
      padding: 1rem
      border: 1px solid #000
      &.disabled
        background-color: $bc-secondary
      &.selected
        background-color: $bc-primary
      h3
        display: inline
        margin-right: 2rem
  .shirts 
    .registration-end
      strong
        font-weight: bold
      a
        @include button-secondary()
    .shirt
      display: grid
      grid-auto-flow: column
      grid-template-columns: 100px 200px
      align-items: center
      column-gap: 5px
      label
        justify-self: end

@media (max-width: 900px)
  .more
    grid-auto-flow: row

</style>